





































































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import AdminMenu from "@/components/AdminMenu.vue";
require("dotenv").config();

@Component({
  components: { AdminMenu },
  props: {
    datesHeaders: {
      type: Array,
      default: () => [
        {
          text: "Dátum",
          value: "date"
        },
        { text: "Počet aktívnych časov", value: "times" },
        { text: "", value: "data-table-expand" },
        { text: "", value: "action" }
      ]
    },
    singleExpand: {
      type: Boolean,
      default: true
    },
    todayDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    reservationDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    }
  }
})
export default class AdminSchedulePage extends Vue {
  dialog = false;
  reservationDates: Array<Record<string, any>> = [];
  todayDate!: string;
  expanded: Array<any> = [];

  private async deleteDate(date: any) {
    confirm("Naozaj chcete odstrániť tento termín?") &&
      (await axios.delete(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/deleteDate?date=" +
          date +
          "&barber=" +
          this.$store.getters.actualBarber
      ));
    this.updateTable();
  }

  private async deactiveTime(time: string, date: string) {
    await axios
      .post(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/deactiveTime?time=" +
          time +
          "&date=" +
          date +
          "&barber=" +
          this.$store.getters.actualBarber
      ) // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(response => {
        this.updateTable();
      });
  }

  private async activateTime(time: string, date: string) {
    await axios
      .post(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/activateTime?time=" +
          time +
          "&date=" +
          date +
          "&barber=" +
          this.$store.getters.actualBarber
      )
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(response => {
        this.updateTable();
      });
  }

  private async save(date: any) {
    if (this.reservationDates.filter(e => e["date"] === date).length == 0) {
      await axios
        .post(
          process.env.VUE_APP_GEMERBARBIER_API +
            "/newFullDate?date=" +
            date +
            "&barber=" +
            this.$store.getters.actualBarber
        )
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then(response => {
          this.updateTable();
          this.dialog = false;
        });
    } else {
      alert("Vybraný dátum už existuje medzi pridanými termínmi");
    }
  }

  @Watch("$store.getters.actualBarber")
  private barberMenuChange() {
    this.updateTable();
  }

  private async activeInactiveTimes(date: string) {
    await axios
      .post(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/activateInactiveTimes?date=" +
          date +
          "&barber=" +
          this.$store.getters.actualBarber
      )
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(response => {
        this.updateTable();
      });
  }

  private async updateTable() {
    this.reservationDates = [];
    await axios
      .get(
        process.env.VUE_APP_GEMERBARBIER_API +
          "/reservationDates?barber=" +
          this.$store.getters.actualBarber
      )
      .then(response => {
        response.data.forEach((dateObject: any) => {
          let count = 0;
          dateObject["availableTimes"].forEach(element => {
            if (element["state"] == "Active") {
              count++;
            }
          });
          dateObject["times"] = count;
          this.reservationDates.push(dateObject);
        });
      });
  }

  private mounted() {
    this.updateTable();
  }
}
